import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrl: './divider.component.css'
})
export class DividerComponent {

}

